import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../config/theme';
import { toastTSpec } from './Toast.tSpec';
import { toastTypeConf } from './Toast.typeConf';

export class Toast
  extends Lightning.Component<toastTSpec, toastTypeConf>
  implements Lightning.Component.ImplementTemplateSpec<toastTSpec>
{
  private _text = this.tag('Text')!;

  static override _template() {
    return {
      x: 0,
      y: 0,

      Bg: {
        w: (w: number) => w,
        h: (h: number) => h,
        rect: true,
        color: Theme.Colors.Secondary,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 18,
        },
      },
      Text: {
        x: (w: number) => w / 2,
        mountX: 0.5,
        y: 5,
        text: {
          textAlign: 'center',
          verticalAlign: 'middle',
          text: '',
          wordWrapWidth: 1800,
          wordWrap: true,
        },
      },
    };
  }

  override _init() {
    this._text.on('txLoaded', () => {
      this.w = Math.min(this._text.finalW + 32, 1920);
      this.h = this._text.finalH + 8;
    });
  }

  get message(): string | undefined {
    return this._text.text?.text;
  }

  set message(val: string | undefined) {
    this._text.patch({
      text: {
        text: val,
      },
    });
  }
}
